import FailureHandler from "./FailureHandler";

function detailOf(error) {
  var data = error.response ? error.response.data : null;
  if (typeof data === "string" && data.length > 0 && data.length < 300) {
    return data;
  }
  var status = error.response ? error.response.status : null;
  if (status) {
    return "Der Server hat mit dem Fehler " + status + " geantwortet.";
  }
  return "Der Server ist nicht erreichbar.";
}

// Abgelaufene Anmeldung und nicht erreichbarer Server fuehren weiterhin auf die
// Fehlerseite. Alles andere blieb bisher unsichtbar - der Benutzer sah eine leere
// Liste und konnte nicht wissen, dass etwas schiefging.
export function reportFailure(component, error, summary) {
  var failureCode = FailureHandler.convertErrorToFailureCode(error);
  if (FailureHandler.routeToFailureSide(failureCode)) {
    FailureHandler.handleServerFailure(component.$router, error);
    return;
  }
  component.$toast.add({
    severity: "error",
    summary: summary,
    detail: detailOf(error),
    life: 8000,
  });
}
